<script>
  import { onMount } from "svelte"
  import { getAutoMpsProjectContext } from "../AutoMpsProjectContext.js";
  import TableHeader from "../../components/table/TableHeader.svelte";
  import Table from "../../components/table/Table.svelte";
  import TableHeaderCell from "../../components/table/TableHeaderCell.svelte";
  import TableBody from "../../components/table/TableBody.svelte";
  import TableRow from "../../components/table/TableRow.svelte";
  import TableCell from "../../components/table/TableCell.svelte";
  import Breadcrumbs from "../parts/Breadcrumbs.svelte";
  import Section from "../../components/layout/Section.svelte";
  import SectionTitle from "../../components/layout/SectionTitle.svelte";
  import Stack from "../../components/layout/Stack.svelte";
  import InputContainer from "../parts/inputs/InputContainer.svelte";
  import Input from "../parts/inputs/Input.svelte";
  import { localizeTableData } from "../plans/new/importStep/parts/tableUtils.js";
  import Loading from "../../components/pages/Loading.svelte";
  import SectionCaption from "../../components/layout/SectionCaption.svelte";
  import Message from "../plans/new/parts/Message.svelte";
  import PropertiesDataTable from "../parts/PropertiesDataTable.svelte";
  import { getDataPropertiesHeadersConstructor } from "../parts/PropertiesDataTableUtils.js";

  export let dataType

  export let importId

  const ctx = getAutoMpsProjectContext()

  /**
   * @type {"loading"|"success"|"empty"|"error"}
   */
  let status = "loading"

  let tableData = {}
  let metadata = {}

  async function getImportData() {
    const response = await fetch(`/api/auto-mps/projects/${$ctx.projectId}/imports/${dataType}/${importId}`)
    if (!response.ok) {
      return status = "error"
    }

    const responseData = await response.json().catch(() => {})
    if (!responseData.data || !responseData.meta) return status = "error"

    metadata = localizeTableData([responseData.meta])[0]

    if (responseData.data.length === 0) return status = "empty"

    tableData = {
      headers: Object.keys(responseData.data[0]),
      rows: responseData.data,
    }

    status = "success"
  }

  $: breadcrumbItems = [
    {
      title: "インポート一覧",
      href: `/auto-mps/projects/${$ctx.projectId}/imports`
    },
    {
      title: dataType,
      href: `/auto-mps/projects/${$ctx.projectId}/imports/${dataType}`
    },
    {
      title: importId,
      active: true,
    }
  ]

  onMount(async () => await getImportData())
</script>

<div class="content-root">
  <Stack direction="vertical" gap="1rem">
    <Breadcrumbs
      items={breadcrumbItems}
    />
    {#if status === "loading"}
      <Loading height="50vh"/>
    {/if}
    {#if status === "error"}
      <Message type="error">
        データの読み込みに失敗しました。
      </Message>
    {/if}
    {#if status === "success" || status === "empty"}
      <Section>
        <Stack direction="vertical" gap="1rem">
          <SectionTitle>
            メタデータ
          </SectionTitle>
          <Stack direction="vertical">
            <InputContainer>
              <span slot="label">インポートID</span>
              <Input disabled={true} value={metadata?.id ?? ""}/>
            </InputContainer>
            <InputContainer>
              <span slot="label">インポート方法</span>
              <Input disabled={true} value={metadata?.importMethod ?? ""}/>
            </InputContainer>
            <InputContainer>
              <span slot="label">インポート日時</span>
              <Input disabled={true} value={metadata?.importedAt ?? ""}/>
            </InputContainer>
          </Stack>
        </Stack>
      </Section>
      <Section>
        <SectionTitle>データ</SectionTitle>
        {#if status === "empty"}
          <SectionCaption>
            このインポートにはデータがありません。
          </SectionCaption>
        {/if}
        {#if status === "success"}
          <PropertiesDataTable
            rows={tableData.rows}
            headers={getDataPropertiesHeadersConstructor(dataType)()}
          />
        {/if}
      </Section>
    {/if}
  </Stack>
</div>

<style>
  .content-root {
    width: 100%;
    height: 100%;
    padding: 1rem;
  }
</style>
